/** Electricity tariff plans /metering/fee/electricity-plan (electricityPlan.vue) */
export default {
  electricityPlanPage: {
    sectionTitle: 'Electricity plans',
    btnAddPlan: 'New plan',
    emptyTable: 'No plans yet',
    emptyNoPermission: 'No permission to view',
    colPlanId: 'Plan ID',
    colPlanName: 'Plan name',
    colPeak: 'Sharp (¥/kWh)',
    colTop: 'Peak (¥/kWh)',
    colFlat: 'Flat (¥/kWh)',
    colValley: 'Valley (¥/kWh)',
    colUpdated: 'Updated',
    colAction: 'Actions',
    btnAdjustPrice: 'Adjust',
    btnLog: 'Log',
    btnBatchBind: 'Batch assign',
    modalTitleEdit: 'Adjust prices',
    modalTitleAdd: 'New plan',
    formPlanName: 'Plan name',
    phPlanName: 'Enter plan name',
    labelPeak: 'Sharp',
    labelTop: 'Peak',
    labelFlat: 'Flat',
    labelValley: 'Valley',
    unitPerKwh: '¥/kWh',
    warnEditAffectsMeters: 'Note: saving will update billing for linked meters.',
    labelEnableRule: 'Activation',
    labelActivationDate: 'Start date',
    phActivationDate: 'Pick start date',
    labelPhoneBound: 'Phone',
    labelVerifyCode: 'SMS code',
    phVerifyCode: 'Enter code',
    sendCode: 'Send code',
    resendIn: 'Resend in {n}s',
    btnCancel: 'Cancel',
    btnConfirm: 'OK',
    drawerBatchBindTitle: 'Batch assign meters',
    tabDedicated: 'Dedicated',
    tabShare: 'Shared',
    tabAir: 'HVAC',
    phSearchMeter: 'Search meter name',
    selectAll: 'Select all',
    tagBound: 'Assigned',
    emptyTreeNoMatch: 'No matching meters',
    emptyTreeNoData: 'No meters',
    selectedMeters: '{count} meter(s) selected',
    btnConfirmBind: 'Assign',
    logTitle: 'Price change log',
    emptyLog: 'No records',
    logColPlanName: 'Plan name',
    logColPeak: 'Sharp (¥/kWh)',
    logColTop: 'Peak (¥/kWh)',
    logColFlat: 'Flat (¥/kWh)',
    logColValley: 'Valley (¥/kWh)',
    logColEnableRule: 'Rule',
    logColEnableStatus: 'Status',
    logColScheduledTime: 'Scheduled',
    logColExecutedTime: 'Executed',
    logColCreated: 'Created',
    logColOperator: 'Operator',
    logColAction: 'Actions',
    btnWithdraw: 'Revoke',
    enableModeImmediate: 'Immediate',
    enableModeScheduled: 'Scheduled',
    enableStatusActive: 'Active',
    enableStatusPending: 'Pending',
    enableStatusDiscarded: 'Discarded',
    tabGroupTenant: 'Tenant',
    tabGroupShare: 'Shared',
    tabGroupAir: 'HVAC',
    groupUngrouped: 'Ungrouped',
    groupAirDefault: 'HVAC meters',
    msgLoadFail: 'Failed to load data',
    msgNoAdd: 'No permission to add',
    msgNoOperate: 'No permission',
    msgSmsSent: 'Code sent',
    msgSmsFail: 'Failed to send code',
    msgNameRequired: 'Please enter a plan name',
    msgPriceZero: 'Price cannot be zero',
    msgPriceIncomplete: 'Please fill in all prices',
    msgEnableRule: 'Please choose activation rule',
    msgActivationDate: 'Please pick start date',
    msgVerifyCode: 'Please enter SMS code',
    titleTip: 'Notice',
    btnOk: 'OK',
    confirmModifyPlan: 'Save changes to this plan?',
    confirmAddPlan: 'Create this plan?',
    msgOpOk: 'Saved',
    msgOpFail: 'Operation failed',
    confirmBindMeters: 'Assign {count} meter(s) to this plan?',
    msgBindOk: 'Assigned',
    msgBindFail: 'Assign failed',
    msgSelectMeters: 'Select at least one meter',
    msgSelectNewMeters: 'Select meters that are not already assigned',
    msgMeterListFail: 'Failed to load meters',
    msgLogFail: 'Failed to load log',
    confirmWithdraw: 'Revoke this change?',
    msgWithdrawOk: 'Revoked',
    msgWithdrawFail: 'Revoke failed'
  }
}
